
import {
    Grid,
    Button,
    Typography,
} from "@material-ui/core";
import React from 'react'
import DynamicTable from "./DynamicTable";
import { NewHirequeTablee } from './constants'


const NewHireQueeTable = ({ tableData }) => {
    let { data, onClick } = tableData


    let table = {
        // header: NewHirequeTablee,
        rows: data?.map(col => [
            col?.id,
            col?.firstName,
            col?.deptName,
            col?.city,
            col?.email,
            col?.employeeStatus,
            // <Button onClick={() => onClick(col)} className="ViewIcon"></Button>,
            <Grid className={` ${(col?.isCompleted) ? `completeTrue` : `CompleteIcon`}`}></Grid>

        ])
    }

     


    return (
        <Grid xs={12} className="LiqTables ">
            <Grid xs={12} className="mt28 mb14">
                <Typography variant="h1" component="h2" className="bold f22">
                    New Hire Queue
                </Typography>
                <DynamicTable tableData={table} />
            </Grid>
        </Grid>

    )
}

export default NewHireQueeTable